import { render, staticRenderFns } from "./SignUpComponent.vue?vue&type=template&id=1746b60e&scoped=true&"
import script from "./SignUpComponent.vue?vue&type=script&lang=js&"
export * from "./SignUpComponent.vue?vue&type=script&lang=js&"
import style0 from "./SignUpComponent.vue?vue&type=style&index=0&id=1746b60e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1746b60e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
